import { useState } from 'react'
import { CopyTextIcon } from 'src/components/Icons/CopyTextIcon'
import { useMobile } from 'src/hooks/useMobile'

interface PixPaymentDetailsProps {
  linkPix: string
  qrCodeBase64Image: string
  productsData: {
    productName: string
    productImage: string
    qttItems: number
    orderPrice: number
  }
}

export const EstructurePixPaymentToast = ({
  linkPix,
  qrCodeBase64Image,
  productsData,
}: PixPaymentDetailsProps) => {
  const { isMobile } = useMobile()
  const [showMobileQRcode, setShowMobileQRcode] = useState(false)

  const copyPixCode = async () => {
    await navigator.clipboard.writeText(linkPix)
  }

  const isSecondMobileLayout = isMobile && showMobileQRcode

  return (
    <div className="w-[85vw] md:w-full">
      {!showMobileQRcode && (
        <div className="flex flex-row gap-3">
          <img
            src={productsData.productImage}
            alt="imagem do produto"
            className="rounded-sm w-12 h-12 md:hidden object-contain"
          />
          <p className="text-white font-medium text-base md:text-xs leading-6 pb-[10px]">
            Pague o pix e finalize sua compra
          </p>
        </div>
      )}
      <div
        className={`flex ${
          isSecondMobileLayout ? 'flex-row gap-6' : 'flex-col'
        }`}
      >
        {!isMobile && (
          <div className="grid grid-cols-[auto_1fr] gap-2 items-center p-1 bg-[#616161] rounded-sm mb-3 max-w-[143px]">
            <img
              src={productsData.productImage}
              alt="imagem do produto"
              className="rounded-sm w-[30px] h-[30px] object-contain"
            />

            <div className="flex flex-col text-mediumGray gap-1">
              <p className="font-medium font-inter text-font-size-1 truncate text-ellipsis max-w-[100px]">
                {productsData.productName}
              </p>
              {productsData.qttItems !== 1 && (
                <p className="font-medium font-inter text-font-size-1">
                  + {productsData.qttItems} produtos
                </p>
              )}
            </div>
          </div>
        )}
        {(isSecondMobileLayout || !isMobile) && (
          <img
            src={`data:image/png;base64,${qrCodeBase64Image}`}
            alt="QR Code para pagamento via Pix"
            className={`w-[143px] h-[143px] object-contain self-center rounded-sm ${
              isSecondMobileLayout ? 'flex-row' : 'flex-col'
            }`}
          />
        )}
        <div
          className={`flex ${
            isSecondMobileLayout ? 'flex-col justify-center w-full' : 'flex-row'
          } gap-2 py-6 md:flex-col md:pt-5 md:py-0`}
        >
          <button
            className="flex flex-row items-center justify-center text-[#EFF1F3] bg-primaryBlue md:bg-transparent underline text-xs font-medium font-inter py-[10px] px-4 gap-1 text-center w-full"
            onClick={copyPixCode}
          >
            Copiar código
            <CopyTextIcon />
          </button>
          {isMobile && (
            <button
              className="text-[#EFF1F3] text-xs font-medium font-inter py-[10px] px-4 bg-secondary-inverted text-center underline w-full"
              onClick={() => setShowMobileQRcode(!showMobileQRcode)}
            >
              {showMobileQRcode ? 'Voltar' : 'Ver QR code >'}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
